import { vesselAlertDetails, vesselAlertJobLink, vesselAlertLink, vesselAlertTone } from '../model/vesselAlerts';
import type { VesselAlert } from '../types/vesselChanges';
import { AlertActionButton, AlertRowDetails, AlertRowTitle } from './VesselAlertParts';
import { FOCUS_RING } from './rowStyles';

interface VesselAlertRowProps {
  alert: VesselAlert;
  /** Navigates to a web route. */
  onOpen: (path: string) => void;
}

/**
 * An ETA alert, or an OMITTED one (Westports lists the call as Omitted): the row opens Vessel changes;
 * jobs with no employee also get "Open job". Neither can be closed with "Not this vessel".
 */
export const VesselAlertRow = ({ alert, onOpen }: VesselAlertRowProps) => {
  const jobLink = vesselAlertJobLink(alert);
  return (
    <li data-kind={alert.kind} className={`border-l-2 ${vesselAlertTone(alert)}`}>
      <button
        type="button"
        onClick={() => onOpen(vesselAlertLink(alert))}
        data-alert={alert.id}
        className={`block w-full px-3 py-2 text-left transition-colors hover:bg-slate-50 ${FOCUS_RING}`}
      >
        <AlertRowTitle alert={alert}>{`${alert.vesselName} ${alert.voyage ?? ''}`.trim()}</AlertRowTitle>
        <AlertRowDetails alert={alert} parts={vesselAlertDetails(alert)} />
      </button>
      {jobLink && (
        <div className="-mt-1 px-2 pb-1.5">
          <AlertActionButton label="Open job" onClick={() => onOpen(jobLink)} />
        </div>
      )}
    </li>
  );
};
